// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bJXU","footer":"styles_footer__2XWFy","passCodeTooltip":"styles_passCodeTooltip__1e0Ey"};